import React from 'react';

const DetailRow = ({ label, value }) => (
  <div className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2.5">
    <div className="text-[11px] font-semibold uppercase tracking-wide text-[var(--fg-muted)]">{label}</div>
    <div className="mt-1 text-sm text-[var(--fg-text)]">{value || '—'}</div>
  </div>
);

const formatCurrency = (value) => {
  if (value == null || value === '') return '—';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
};

const FundingLenderCriteriaPanel = ({ lender }) => {
  if (!lender) return null;

  const speedLabel = lender.fundingSpeedDaysMin != null || lender.fundingSpeedDaysMax != null
    ? `${lender.fundingSpeedDaysMin ?? '—'}-${lender.fundingSpeedDaysMax ?? '—'} days`
    : '—';

  return (
    <div className="space-y-3">
      <p className="text-sm text-[var(--fg-muted)]">
        Preferred fit criteria used for matching. Amounts and speed are estimated, not guaranteed.
      </p>
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
        <DetailRow label="Min credit score" value={lender.minCreditScore} />
        <DetailRow label="Min monthly revenue" value={formatCurrency(lender.minMonthlyRevenue)} />
        <DetailRow label="Min time in business" value={lender.minTimeInBusinessMonths ? `${lender.minTimeInBusinessMonths} months` : '—'} />
        <DetailRow label="Requested amount range" value={`${formatCurrency(lender.minRequestedAmount)} – ${formatCurrency(lender.maxRequestedAmount)}`} />
        <DetailRow label="Estimated speed" value={speedLabel} />
        <DetailRow label="Preferred document status" value={lender.preferredDocumentStatus} />
        <DetailRow label="States supported" value={(lender.statesSupported || []).join(', ')} />
        <DetailRow label="Industries supported" value={(lender.industriesSupported || []).join(', ') || 'All'} />
        <DetailRow label="Excluded industries" value={(lender.excludedIndustries || []).join(', ') || 'None'} />
        <DetailRow label="Accepts startups" value={lender.acceptsStartups ? 'Yes' : 'No'} />
        <DetailRow label="Accepts low credit" value={lender.acceptsLowCredit ? 'Yes' : 'No'} />
        <DetailRow label="Commission available" value={lender.commissionAvailable ? 'Yes' : 'No'} />
      </div>
      {lender.notes ? (
        <div className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2 text-sm text-[var(--fg-muted)]">
          {lender.notes}
        </div>
      ) : null}
    </div>
  );
};

export default FundingLenderCriteriaPanel;
